import api from '@/api'

//获取底部链接
export async function getBottomLinks() {
  var paramStr='SkipCount=0';
  paramStr += '&MaxResultCount=10';
  return api.get('/api/services/app/FrontendBottomLink/GetBottomLinksBySupply?'+paramStr)
}

//获取底部链接
export async function getBottomLink(params) {
  var paramStr='id='+params.id;
  return api.get('/api/services/app/FrontendBottomLink/GetBottomLinkBySupply?'+paramStr)
}


//添加意见反馈
export async function addFeedback(param) {
  return api.post('/api/services/app/FrontendFeedback/CreateOrEditBySupply',param)
}


// WEBPACK FOOTER //
// ./src/api/bottomLink.js